export default __webpack_public_path__ + "static/media/icon-facebook-link.bbe14d23.svg";